import React from 'react';
import ReactModal from 'react-modal';
import Loadable from '../common/Loadable';

const FeaturesCompareModal = props => (
  <ReactModal
    isOpen={true}
    className="reveal full"
    overlayClassName="reveal-overlay"
    appElement={document.getElementById('byo-web-ui')}>
    <Loadable
      loader={() => import('../components/features/Features')}
      render={Features => <Features {...props} />}
    />
  </ReactModal>
);

export default FeaturesCompareModal;
